export default __webpack_public_path__ + "static/media/carama-loader.76cf1585.gif";